var _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoSteam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.579102 9.33297C0.579102 11.8118 1.42986 13.9216 3.13138 15.6622L3.12839 15.6651C3.15726 15.6948 3.1875 15.7223 3.21671 15.7514L3.21816 15.7529C4.78556 17.3151 6.73338 18.2504 8.91702 18.4098L9.58716 18.4368C12.0334 18.4368 14.1302 17.5637 15.8776 15.8174C17.6174 14.0711 18.4873 11.9732 18.4873 9.52384L0.579102 9.33297Z",
    fill: "#FFF064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72922 0.317932C7.24903 0.317932 5.13807 1.16821 3.39635 2.86876L3.39344 2.86569C3.36381 2.89463 3.3363 2.92485 3.30718 2.95404L3.30564 2.95541C1.7426 4.52191 0.806657 6.46871 0.647193 8.65111L0.620117 9.32087C0.620117 11.7657 1.49377 13.8614 3.24107 15.6077C4.98837 17.3465 7.0874 18.2159 9.53815 18.2159L9.72922 0.317932Z",
    fill: "#FFF064"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1868_1721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 15,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.54603C4.84951 1.69763 7.10057 0.773371 9.75318 0.773257C11.1319 0.763183 12.4953 1.06147 13.7437 1.64627C14.9243 2.22856 16.0853 3.17257 17.2266 4.47829L15.2667 6.35432C13.7712 4.36421 11.9491 3.36913 9.80033 3.36907C7.8719 3.36907 6.25445 4.03377 4.94799 5.36316L3 3.54603Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1868_1721)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.12598,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.63086,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.13574,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.63965,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.14453,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.64844,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.65723,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.16113,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.66602,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.16992,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6748,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.17871,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.68359,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1875,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6924,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1963,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.7012,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2051,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.71,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2139,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7188,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2227,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7275,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2314,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7363,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2402,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7451,
    y: -3.42175,
    width: 0.220705,
    height: 16.5048,
    fill: "#5ABEF0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 9.51787V8.92033H10.8897V11.4868H15.4819C15.3547 12.7603 14.7464 13.854 13.657 14.7681C12.5673 15.6744 11.3387 16.1275 9.97116 16.1275C8.36474 16.1275 6.87373 15.522 5.49814 14.311C4.02677 13.0064 3.29118 11.3463 3.29135 9.33058H0.5C0.5 11.9009 1.41849 14.1041 3.25548 15.94C5.0924 17.7681 7.29914 18.6821 9.87567 18.6821C12.5156 18.6821 14.6905 17.7367 16.4004 15.8461C17.1208 15.0619 17.6693 14.1359 18.0107 13.1275C18.1754 12.5911 18.2959 12.0422 18.3712 11.4862C18.4594 10.8338 18.5025 10.1762 18.4999 9.51787Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoSteam);
export default __webpack_public_path__ + "static/media/go-steam.2d7cfbec90b3659a2ba0744c24154622.svg";
export { ForwardRef as ReactComponent };